import { render, staticRenderFns } from "./AlignmentTabs.vue?vue&type=template&id=e58799b0"
import script from "./AlignmentTabs.vue?vue&type=script&lang=js"
export * from "./AlignmentTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports